import React from 'react';

import Icon from '../Icon/Icon';

const TasteExplorationIcon = (props) => {
    return (
        <Icon width='40' height='40' {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21.5957 8.49512V13.8394H22.7697C22.7697 13.8394 23.342 18.8823 23.342 20.5176C23.342 21.6741 23.342 27.8735 23.342 31.4092C28.1858 29.9513 31.7154 25.46 31.7154 20.1392C31.7154 14.2007 27.313 9.30103 21.5957 8.49512'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.16699 20.1392C8.16699 25.46 11.6968 29.9513 16.5406 31.4092C16.5406 27.8735 16.5406 21.6741 16.5406 20.5176C16.5406 18.8823 17.1129 13.8394 17.1129 13.8394H18.2869V8.49512C12.5698 9.30103 8.16699 14.2007 8.16699 20.1392'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19.9999 35.1056C11.7289 35.1056 5 28.3761 5 20.1053C5 13.8118 8.97294 8.14263 14.8858 5.99851C15.3046 5.84673 15.767 6.06478 15.9188 6.48163C16.0708 6.90062 15.8544 7.3645 15.4357 7.51628C10.1585 9.42953 6.6129 14.4895 6.6129 20.1053C6.6129 27.4868 12.6184 33.4916 19.9999 33.4916C27.3816 33.4916 33.3871 27.4868 33.3871 20.1053C33.3871 14.4895 29.8413 9.42953 24.5641 7.51628C24.1453 7.3645 23.929 6.90062 24.081 6.48163C24.233 6.06478 24.6958 5.84673 25.1139 5.99851C31.0271 8.14263 35 13.8118 35 20.1053C35 28.3761 28.2709 35.1056 19.9999 35.1056'
                fill='#34303D'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M23.341 34.5346C22.9847 34.5346 22.6959 34.246 22.6959 33.889V20.5176C22.6959 19.4039 22.418 16.6163 22.2523 15.0558C22.2179 14.7287 21.9447 14.4829 21.6174 14.4829H18.2635C17.936 14.4829 17.6631 14.7287 17.6284 15.0558C17.4628 16.6163 17.1849 19.4039 17.1849 20.5176V33.889C17.1849 34.246 16.896 34.5346 16.5397 34.5346C16.1833 34.5346 15.8945 34.246 15.8945 33.889V20.5176C15.8945 19.344 16.1769 16.5073 16.3454 14.919C16.4497 13.9356 17.2742 13.1938 18.2635 13.1938H21.6174C22.6065 13.1938 23.431 13.9356 23.5354 14.919C23.7038 16.5073 23.9862 19.344 23.9862 20.5176V33.889C23.9862 34.246 23.6974 34.5346 23.341 34.5346'
                fill='#34303D'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.9323 13.1938H20.9509V6.289H18.9323V13.1938ZM21.5957 14.4829H18.2868C17.9304 14.4829 17.6416 14.1943 17.6416 13.8394V5.64345C17.6416 5.28859 17.9304 5 18.2868 5H21.5957C21.9521 5 22.2409 5.28859 22.2409 5.64345V13.8394C22.2409 14.1943 21.9521 14.4829 21.5957 14.4829V14.4829Z'
                fill='#34303D'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M22.1152 29.6305L18.5502 31.0884C18.4012 31.1483 18.2312 31.0777 18.1703 30.9281L17.7259 29.84C17.6649 29.6925 17.7363 29.5215 17.8851 29.4616L21.4504 28.0037C21.5994 27.9438 21.7693 28.0144 21.8301 28.164L22.2747 29.2521C22.3356 29.3996 22.2642 29.5706 22.1152 29.6305'
                fill='#00D1D2'
            />
        </Icon>
    );
};

export default TasteExplorationIcon;
